import { __spreadArray, __read } from 'tslib';
import dateUtils from './dateUtils.esm.js';

var daysInWeek = 7;
var defaultLocale = 'en-US';
var weekdayIndexes = {
    sun: 0,
    mon: 1,
    tue: 2,
    wed: 3,
    thu: 4,
    fri: 5,
    sat: 6
};
var capitalizeFirstLetter = function (_a, locale) {
    var _b = __read(_a), firstChar = _b[0], rest = _b.slice(1);
    var capitalizedFirstLetter = firstChar.toLocaleUpperCase(locale);
    return __spreadArray([capitalizedFirstLetter], __read(rest), false).join('');
};
var getIntDateTimeFormat = function (locale, options) {
    try {
        return new Intl.DateTimeFormat(locale, options);
    }
    catch (e) {
        return new Intl.DateTimeFormat(defaultLocale, options);
    }
};
var getWeekStartIndex = function (l10n) {
    var firstWeekdayCode = l10n.getWeekData().firstDay || 'sun';
    var firstWeekdayIndex = weekdayIndexes[firstWeekdayCode];
    return firstWeekdayIndex;
};
var getWeekdayNames = function (l10n, locale, weekday) {
    if (locale === void 0) { locale = defaultLocale; }
    if (weekday === void 0) { weekday = 'long'; }
    var firstWeekdayIndex = getWeekStartIndex(l10n);
    var format = getIntDateTimeFormat(locale, { weekday: weekday }).format;
    return Array.from(Array(daysInWeek).keys()).map(function (weekdayIndex) {
        // WeekIndex is zero based.
        var day = weekdayIndex + 1 + firstWeekdayIndex;
        // 2022-5-1 is a Sunday date.
        var weekDayName = format(new Date(2022, 4, day));
        // In some locales, days are capitalized shown as the first word in a phrase.
        return ['pt-BR', 'da-DK', 'nl-NL', 'nb-NO', 'no-NO', 'sv-SE'].includes(locale)
            ? capitalizeFirstLetter(weekDayName, locale)
            : weekDayName;
    });
};
var getMonthTitle = function (year, month, locale, monthLength) {
    if (locale === void 0) { locale = defaultLocale; }
    if (monthLength === void 0) { monthLength = 'long'; }
    var format = getIntDateTimeFormat(locale, { year: 'numeric', month: monthLength }).format;
    // MonthIndex is zero based.
    var monthLabel = format(new Date(year, month, 3));
    // In some locales, months are capitalized as the first word in a phrase.
    return ['da-DK'].includes(locale) ? capitalizeFirstLetter(monthLabel, locale) : monthLabel;
};
var getAriaLiveDate = function (ISODateString, locale) {
    if (!ISODateString) {
        return '';
    }
    var format = getIntDateTimeFormat(locale, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        weekday: 'long'
    }).format;
    try {
        var date = dateUtils.getDateFromString(ISODateString);
        return format(date);
    }
    catch (e) {
        return '';
    }
};

export { daysInWeek, defaultLocale, getAriaLiveDate, getIntDateTimeFormat, getMonthTitle, getWeekStartIndex, getWeekdayNames };
